import { render, staticRenderFns } from "./newDashBoard.vue?vue&type=template&id=b50e6494&scoped=true&"
import script from "./newDashBoard.vue?vue&type=script&lang=js&"
export * from "./newDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./newDashBoard.vue?vue&type=style&index=0&id=b50e6494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50e6494",
  null
  
)

export default component.exports